import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import styled from 'styled-components';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import { H5 } from 'UIComponents/elements/headings';
// @ts-expect-error untyped module
import PreloadedIframeProxy from 'ContentEditorUI/components/temp/PreloadedIframeProxytoExtract';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSidebarIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
// @ts-expect-error untyped module
import { updateSidebarSearchQuery } from 'ContentEditorUI/redux/actions/sidebarActions';
// @ts-expect-error untyped module
import SidebarIframeStylesManager from 'ContentEditorUI/utils/SidebarIframeStylesManager';
import PatagoniaSearchBarContainer from 'ContentEditorUI/js/components/sidebar/PatagoniaSearchBarContainer';
import { HEFFALUMP, OLAF } from 'HubStyleTokens/colors';

// prevent More dropdown from rendering
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaAddModuleMenuWrapper = styled.div.withConfig({
  displayName: "PatagoniaAddModuleMenu__PatagoniaAddModuleMenuWrapper",
  componentId: "sc-6ta6yd-0"
})([".add-module-tab{padding-left:12px;padding-right:12px;background-color:unset;border:none;}[data-tab-selected='true'],[data-tab-selected='true']:hover{background-color:", ";color:", ";font-weight:400;}"], HEFFALUMP, OLAF);
const PatagoniaAddModuleMenu = ({
  categories,
  categoryYamlMapping,
  categorySelected,
  handleSelectedCategory,
  sidebarIframeIsVisible,
  sidebarSearchResultsMap,
  sidebarSearchQuery
}) => {
  const dispatch = useDispatch();
  const isInNonDefaultBreakpointMode = useSelector(getIsInNonDefaultBreakpointMode);
  const handleSearchInput = useCallback(input => {
    dispatch(updateSidebarSearchQuery(input));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(PatagoniaAddModuleMenuWrapper, {
    children: [/*#__PURE__*/_jsx(PatagoniaSearchBarContainer, {
      sidebarSearchQuery: sidebarSearchQuery,
      handleSearchInput: handleSearchInput,
      className: "p-all-3",
      isDisabled: isInNonDefaultBreakpointMode
    }), categories.length > 1 && /*#__PURE__*/_jsx(UITabs, {
      selected: categorySelected,
      use: "toolbar",
      fill: true,
      bordered: true,
      className: "p-x-2",
      panelClassName: "p-all-0",
      children: categories.map(category => {
        return /*#__PURE__*/_jsx(UITab, {
          disabled: isInNonDefaultBreakpointMode,
          tabId: category,
          className: "add-module-tab",
          title: /*#__PURE__*/_jsx(_Fragment, {
            children: sidebarSearchQuery ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: categoryYamlMapping[`${category}_WITH_COUNT`],
              options: {
                count: sidebarSearchResultsMap[category].count
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: categoryYamlMapping[category]
            })
          }),
          onClick: () => handleSelectedCategory(category),
          children: /*#__PURE__*/_jsx("div", {
            className: "patagonia-sidebar-add-tiles",
            children: sidebarIframeIsVisible && /*#__PURE__*/_jsx(PreloadedIframeProxy, {
              proxyTop: true,
              proxyDisplay: true,
              proxyResizeDependencies: [],
              iframeWrapperElement: getSidebarIframeWrapperElement(),
              isSidebar: true,
              iframeStylesManager: SidebarIframeStylesManager
            })
          })
        }, `addModuleCategory-${category}`);
      })
    }), categories.length === 1 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-left-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: categoryYamlMapping[categories[0]]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "patagonia-sidebar-add-tiles",
        children: sidebarIframeIsVisible && /*#__PURE__*/_jsx(PreloadedIframeProxy, {
          proxyTop: true,
          proxyDisplay: true,
          proxyResizeDependencies: [],
          iframeWrapperElement: getSidebarIframeWrapperElement(),
          isSidebar: true,
          iframeStylesManager: SidebarIframeStylesManager
        })
      })]
    })]
  });
};
export default PatagoniaAddModuleMenu;